export const loadGTM = (id?: string, dataLayerName = 'dataLayer') => {
  if (!window || !id) return;

  window[dataLayerName] = window[dataLayerName] || [];
  window[dataLayerName].push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js',
  });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${id}`;
  document.head.appendChild(script);

  script.onload = () => console.info('GTM chargé ✅');
  script.onerror = () => console.error('Erreur de chargement GTM ❌');
};
